import {Adresse} from "./Adresse";
import {Agency} from "./Agency";

export class User {
 	// Properties
	FCT_ID: number;
	USR_ID: number | null;
	USR_NOM: string | null;
	USR_EMAIL: string | null;
	USR_PRENOM: string | null;
	USR_NUM_AGREEMENT: string | null;
	USR_NUMERO_EXTERNE: string | null;
	USR_TEL_MOBILE: string | null;
	USR_SIMU_TOTAL: number | null;
	USR_SIMU_USED: number | null;
	USR_ADR!: Adresse | null
	USR_ORG!: Agency | null;
	USR_ID_PARENT!: number | null;
	SIN_ID?: number | null;
	ACTE_ID?: number | null;
	USR_REFERER?: string | null;
	// Other Properties
	[key: string]: any;

	// Constructor
	constructor(
		FCT_ID: number = 3, //Client
		USR_ID: number | null = null,
		USR_NOM: string | null = "",
		USR_EMAIL: string | null = "",
		USR_PRENOM: string | null = "",
		USR_NUM_AGREEMENT: string | null = "",
		USR_NUMERO_EXTERNE: string | null = "",
		USR_TEL_MOBILE: string | null = "",
		USR_SIMU_TOTAL: number | null = null,
		USR_SIMU_USED: number | null = null,
		USR_ADR: Adresse | null = null,
		USR_ORG: Agency | null = null,
		USR_ID_PARENT: number | null = null
	) {
		this.FCT_ID = FCT_ID;
		this.USR_ID = USR_ID;
		this.USR_NOM = USR_NOM;
		this.USR_EMAIL = USR_EMAIL;
		this.USR_PRENOM = USR_PRENOM;
		this.USR_NUM_AGREEMENT = USR_NUM_AGREEMENT;
		this.USR_NUMERO_EXTERNE = USR_NUMERO_EXTERNE;
		this.USR_TEL_MOBILE = USR_TEL_MOBILE;
		this.USR_SIMU_TOTAL = USR_SIMU_TOTAL;
		this.USR_SIMU_USED = USR_SIMU_USED;
		this.USR_ADR = USR_ADR;
		this.USR_ORG = USR_ORG;
		this.USR_ID_PARENT = USR_ID_PARENT;
	}
}
